import React, { useState } from 'react'
import editEventImg from "../../assets/images/Digital Marketing/editEventImg.jpg"
import { Modal, Row } from 'reactstrap'
import { FetchNodePostData, FetchPostData } from 'utils/common-fetchData';
import secureLocalStorage from 'react-secure-storage';
import moment from 'moment';
import Loader from 'pages/Separate/Loader';
import Swal from 'sweetalert2';
// function calculateTotalTime(logs) {
//     let totalMinutes = 0;
//     console.log("logssssssssssss", logs)
//     logs.forEach(entry => {
//         const { punch_date, punch_in, punch_out } = entry;

//         if (punch_in && punch_out) {
//             const inTime = new Date(`${punch_date}T${punch_in}`);
//             const outTime = new Date(`${punch_date}T${punch_out}`);

//             // Handle possible cross-midnight shifts
//             if (outTime < inTime) {
//                 outTime.setDate(outTime.getDate() + 1);
//             }

//             const duration = (outTime - inTime) / (1000 * 60); // in minutes
//             totalMinutes += duration;
//         }
//     });

//     function formatDuration(minutes) {
//         const hrs = Math.floor(minutes / 60);
//         const mins = Math.round(minutes % 60);
//         return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
//     }

//     return formatDuration(totalMinutes);
// }

function calculateTotalTime(logs) {
  let totalDuration = moment.duration(0);

  logs.forEach(entry => {
    const { punch_date, punch_in, punch_out } = entry;

    if (punch_in && punch_out) {
      let inTime = moment(`${punch_date} ${punch_in}`);
      let outTime = moment(`${punch_date} ${punch_out}`);

      // Handle cross-midnight shift
      if (outTime.isBefore(inTime)) {
        outTime.add(1, "day");
      }

      totalDuration.add(moment.duration(outTime.diff(inTime)));
    }
  });

  const hours = String(Math.floor(totalDuration.asHours())).padStart(2, "0");
  const minutes = String(totalDuration.minutes()).padStart(2, "0");
  const seconds = String(totalDuration.seconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}


const PunchLogs = ({ data }) => {

    const [addHours, setAddHours] = useState(false)
    const [reason, setReason] = useState('')
    const [description, setDescription] = useState('')
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [isLoading, setLoading] = useState(false)
    const token = secureLocalStorage.getItem('auth_token')
    const onAddTime = async (e) => {
        e.preventDefault();
        const date = new Date()
        const formEntries = {
            userId: localStorage.getItem('auth_id'),
            startTime: startTime,
            endTime: endTime,
            reason: reason,
            description: description,
            date: moment(date).format('YYYY-MM-DD')
        };
        const res = await FetchNodePostData(setLoading, `wfhpunch/addWfhPunch`, token, formEntries);
        if (res?.data?.status) {
            setAddHours(false)
            setReason('')
            setDescription('')
            setStartTime('')
            setEndTime('')
            Swal.fire({
                icon: 'success',
                text: "Your punch log has been added successfully. You can view it in the Punch Log section.",
            })
        }

    }
    return (
        <div>

            <Row className="align-items-center justify-content-between">
                <div className="col-md-5 d-flex justify-content-end align-items-center flex-column ps-3">
                    <div className="text-center">
                        <img
                            src={editEventImg}
                            alt="Addepe"
                            style={{ width: "90%" }}
                        />
                    </div>
                    <small className='text-danger fw-bold'>* Before you log off, take a quick peek at today’s work hours ⏱️. Any mismatch could affect your salary, and only you can set it right. A 10-second check now saves later trouble!</small>
                </div>
                <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                    <div className="d-flex gap-2 col-md-12 mb-5 position-relative align-items-start justify-content-between">
                        <a className="text-purple pt-2 px-2 rounded work-status text-center col-md-4">
                            <h5>Working Hours</h5>
                            <h5>
                                {calculateTotalTime(data)} Hrs
                            </h5>
                        </a>
                        <a className="btn btn-sm btn-primary me-1 d-flex align-items-center mt-3" onClick={() => setAddHours(true)}>
                            <i className="bx bx-plus fs-6"></i>
                            Add
                        </a>
                    </div>
                    <div className="w-100">
                        <div className="punch-body mb-2" style={{ scrollbarWidth: "thin" }}>
                            <table className="table table-bordered mb-0 table ">
                                <thead>
                                    <tr>
                                        <th className="header time-taken-user">Sr No.</th>
                                        <th className="text-center header col-1">
                                            Punch In
                                        </th>
                                        <th className="text-center header col-1">
                                            Punch Out
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.map((obj, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className="text-center">
                                                    {obj?.punch_in}
                                                </td>
                                                <td className="text-center">
                                                    {obj?.punch_out}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </Row>

            <Modal isOpen={addHours} size="md" className="" centered>
                {isLoading && <Loader />}
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Add Punch Logs</h5>
                    <button
                        type="button"
                        onClick={() => {
                            setAddHours(false)
                        }}
                        className="btn-modal-close"
                    >
                        <span aria-hidden="true" className="btn-modal-span">
                            ×
                        </span>
                    </button>
                </div>
                <div className="modal-body">
                    <form className="row" onSubmit={onAddTime}>
                        <div className="col-md-6 mt-2">
                            <label>Start Time <span className='text-danger'>*</span></label>
                            <input
                                type="time"
                                step="1"
                                className="form-control"
                                placeholder="Enter Time"
                                required
                                value={startTime}
                                onChange={(e) => setStartTime(e.target.value)}

                            />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label>End Time <span className='text-danger'>*</span></label>
                            <input
                                type="time"
                                step="1"
                                className="form-control"
                                placeholder="Enter Time"
                                required
                                value={endTime}
                                onChange={(e) => setEndTime(e.target.value)}
                            />
                        </div>
                        <div className="col-md-12 mt-3">
                            <label>Reason <span className='text-danger'>*</span></label>
                            <select className='border-radius form-select' required
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                            >
                                <option value=''>Select Reason</option>
                                <option value='on-call'>On Call</option>
                                <option value='other'>Other</option>
                            </select>
                        </div>
                        {reason != '' ? (
                            <div className="col-md-12 mt-3">
                                <label>Actual Reason <span className='text-danger'>*</span></label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Actual Reason"
                                    required
                                    rows={5}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                        ) : null}
                        <div className="mt-4">
                            <button
                                type="submit"
                                className="border-radius btn btn-purple"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    )
}

export default PunchLogs
